export const translations = {
  de: {
    seo: {
      title: 'Milok Gerüstbau - Zuverlässiger Partner & Jobs in Deutschland',
      description: 'Professioneller Gerüstbau in ganz Deutschland. Milok bietet Sicherheit, Qualität und attraktive Jobs für Gerüstbauer. Kontaktieren Sie uns für Projekte oder Karriere!',
      keywords: 'Gerüstbau, Milok, Deutschland, Gerüstbauer Jobs, Baugerüst, Sicherheit, Fassadengerüst, Industriegerüst'
    },
    header: {
      nav: [
        { label: 'Über uns', href: '#aboutus' },
        { label: 'Leistungen', href: '#services' },
        /* { label: 'Sicherheit', href: '#safety' }, */
        { label: 'Referenzen', href: '#references' },
        /* { label: 'Unser Team', href: '#company-life' }, */
        /* { label: 'Karriere', href: '#career' }, */
        { label: 'Kontakt', href: '#contact' }
      ]
    },
    hero: {
      title: 'Die beste Gerüstbau Firma<br class="hidden md:block"> weit und breit.',
      subtitle: 'Zuverlässigkeit, Qualität und Sicherheit auf jeder Baustelle. Ihr Partner für professionellen Gerüstbau.',
      button1: 'Unsere Referenzen',
      button2: 'Melden Sie sich'
    },
    about: {
      title: 'Über uns — lernen Sie uns kennen.',
      content: 'Wir sind eine junge Firma die ende des Jahres 2024 gegründet wurde. Im Laufe unserer Existenz haben wir mit Firmen aus ganzem Deutschland gearbeitet, auf größeren aber auch kleineren Projekten. Jeder Auftrag ist für uns interessant, da er uns neue Erfahrungen bietet und uns weiter bringt. Die können wir dann in der Zukunft anwenden. Für uns ist es wichtig, gute Leistungen zu erbringen, Abmachungen und Termine zu halten und unsere Prozesse zu verbessern. Wenn unsere Kunden und Arbeiter zufrieden sind, sind wir es auch.'
    },
    services: {
      title: 'Unsere Detaillierten Leistungen',
      subtitle: 'Wir bieten maßgeschneiderte Gerüstlösungen für jedes Projekt, von Standardanwendungen bis hin zu komplexen Spezialkonstruktionen.',
      items: [
        { title: 'Fassadengerüst', description: 'Perfekt für Renovierungen, Dämmarbeiten und Fassadenanstriche. Wir bieten sicheren und effizienten Zugang zu jeder Gebäudeaußenseite, damit Ihr Projekt reibungslos und termingerecht verläuft.' },
        { title: 'Industriegerüst', description: 'Komplexe Industrieumgebungen erfordern spezielle Lösungen. Wir planen und errichten robuste Gerüste für Fabriken, Kraftwerke und Produktionshallen, die höchsten Sicherheits- und Zugänglichkeitsstandards entsprechen.' },
        { title: 'Sonderkonstruktionen', description: 'Von historischen Gebäuden bis hin zu komplexen architektonischen Entwürfen ist keine Herausforderung zu groß. Unser Team entwickelt individuelle Gerüstlösungen für einzigartige Projekte, die kreatives Denken und Präzision erfordern.' }
      ]
    },
    safety: {
      title: 'Sicherheit an erster Stelle',
      subtitle: 'Unser Engagement für höchste Sicherheitsstandards auf jeder Baustelle.',
      content: 'Sicherheit ist das Fundament unserer Arbeit. Wir halten uns strikt an alle gesetzlichen Vorschriften und implementieren darüber hinausgehende Maßnahmen, um die Sicherheit aller Beteiligten zu gewährleisten. Regelmäßige Schulungen, moderne Ausrüstung und sorgfältige Planung sind für uns selbstverständlich.',
      points: [
        { title: 'Zertifizierte Mitarbeiter', description: 'Unser gesamtes Team ist nach den neuesten Standards geschult und zertifiziert.' },
        { title: 'Regelmäßige Inspektionen', description: 'Alle Gerüste werden vor und während des Einsatzes regelmäßig von Fachpersonal geprüft.' },
        { title: 'Hochwertiges Material', description: 'Wir verwenden ausschließlich geprüftes und gewartetes Material von namhaften Herstellern.' },
        { title: 'Persönliche Schutzausrüstung (PSA)', description: 'Das Tragen der vollständigen PSA ist auf unseren Baustellen obligatorisch.' }
      ]
    },
    gallery: {
      title: 'Projekte & Referenzen',
      subtitle: 'Sehen Sie sich eine Auswahl unserer erfolgreich abgeschlossenen Projekte an.',
      imageAlt: 'Baustelle Referenz'
    },
    companyLife: {
      title: 'Unser Team, unsere Stärke',
      subtitle: 'Das Fundament unseres Erfolgs sind unsere engagierten und qualifizierten Mitarbeiter.',
      content: 'Jeder unserer Mitarbeiter bringt langjährige Erfahrung, Professionalität und ein hohes Maß an Zuverlässigkeit mit. Wir sind stolz auf ein Team, das nicht nur durch technisches Know-how, sondern auch durch Teamgeist und Engagement für höchste Qualitäts- und Sicherheitsstandards überzeugt. Diese Hingabe ist es, die es uns ermöglicht, bei jedem Projekt außergewöhnliche Ergebnisse zu liefern.',
      values: ['Teamgeist', 'Erfahrung', 'Qualität', 'Energie'],
      quote: '"Jeder Einzelne ist wichtig für den Erfolg des Ganzen."'
    },
    whyUs: {
        points: [
            { title: 'Zuverlässigkeit', description: 'Wir halten unsere Termine und Absprachen ein.' },
            { title: 'Qualität', description: 'Höchste Standards bei Material und Ausführung.' },
            { title: 'Sicherheit', description: 'Sicherheit steht bei uns an erster Stelle.' }
        ]
    },
    career: {
      title: 'Karriere bei Milok — Wieso uns',
      imageAlt: 'Gerüstbauer bei der Arbeit',
      benefits: [
        { title: 'Erfahrung', description: 'Unsere Gerüstbauer haben langjährige Erfahrungen im Gerüstbau.' },
        { title: 'Vielseitigkeit', description: 'Wir können mit verschiedenen Gerüsten aus Layher, Plettac, Peri arbeiten.' },
        { title: 'Professionalität', description: 'Zuverlässigkeit, Qualität, hoher Arbeitseinsatz und Sicherheit.' },
        { title: 'Team-Struktur', description: '1 LKW Fahrer und 1 Deutschsprechender in jeder Gruppe.' }
      ]
    },
    testimonials: {
      title: 'Was unsere Gerüstbauer sagen',
      items: [
        { quote: "Ich arbeite seit März 2025 mit Milok zusammen. Ich bin mit der Vorgehensweise des Unternehmens zufrieden und erhalte mein Geld auch pünktlich.", author: "Peter" },
        { quote: "Ich bin seit der Gründung des Unternehmens dabei. Ich mag die individuelle Herangehensweise, das pünktliche Geld und auch die Möglichkeit, mein Deutsch zu verbessern, das ich jeden Tag bei der Arbeit nutze.", author: "František B." },
        { quote: "Die Unternehmensleitung steht zur Verfügung, wenn ich etwas lösen muss. Während der Schicht erhalte ich Unterstützung vom Management, z.B. Auch in Form einer Dolmetschung, als ich plötzlich Zahnschmerzen hatte.", author: "Lukáš B." }
      ]
    },
    stats: {
      title: 'Wieso mit uns zusammenarbeiten?',
      items: [
        { title: 'Zufriedene Partner', value: '7+', description: 'Starke Partnerschaften im ersten Jahr aufgebaut.', items: ['Hoher Arbeitseinsatz', 'Flexibilität', '0 Unfälle'] },
        { title: 'Unsere Gerüstbauer', value: '30+', description: 'Neue Fachkräfte im ersten Jahr an Bord geholt.', items: ['12 LKW Fahrer', '13 Deutschsprechende', 'Erfahrung Industrie & Fassade'] },
        { title: 'Projekte', value: '55+', description: 'Erfolgreich abgeschlossene Projekte pro Jahr.', items: ['Schulen', 'Krankenhäuser', 'Wohngebäude & Einfamilienhäuser'] }
      ]
    },
    contact: {
      title: 'Impressum & Kontakt',
      subtitle: 'Haben Sie Fragen oder möchten Sie ein Projekt besprechen? Kontaktieren Sie uns!',
      infoTitle: 'Kontaktinformationen',
      presenceTitle: 'Online Präsenz',
      facebook: 'Unsere Facebook Seite',
      whatsapp: 'Meetings via WhatsApp',
      formTitle: 'Schreiben Sie uns eine Nachricht',
      formThanks: 'Vielen Dank!',
      formSuccess: 'Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns in Kürze bei Ihnen melden.',
      formNewMessage: 'Neue Nachricht schreiben',
      formNameLabel: 'Ihr Name',
      formNamePlaceholder: 'Max Mustermann',
      formEmailLabel: 'Ihre E-Mail',
      formEmailPlaceholder: 'name@beispiel.com',
      formMessageLabel: 'Ihre Nachricht',
      formMessagePlaceholder: 'Ihre Anfrage...',
      formSendButton: 'Nachricht senden',
      formErrorServer: 'Serverfehler. Senden Sie die E-Mail bitte manuell:',
      formErrorNetwork: 'Netzwerkfehler. Senden Sie die E-Mail bitte manuell:',
      formSubmitting: 'Wird gesendet...',
      formFallbackButton: 'In E-Mail-App öffnen'
    },
    footer: {
      copyright: 'Copyright &copy; {{year}} by Milok Gerüstbau. All rights reserved.'
    }
  },
  sk: {
    seo: {
      title: 'Milok Lešenárstvo - Práca v Nemecku pre lešenárov',
      description: 'Profesionálne lešenie v Nemecku. Hľadáte prácu? Milok ponúka prácu pre lešenárov, istotu, dobrý zárobok a kvalitné vybavenie. Kontaktujte nás!',
      keywords: 'lešenárstvo, lešenie, práca v Nemecku, lešenári, Nemecko, Milok, stavebníctvo, práca pre lešenárov'
    },
    header: {
      nav: [
        { label: 'O nás', href: '#aboutus' },
        { label: 'Služby', href: '#services' },
        /* { label: 'Bezpečnosť', href: '#safety' }, */
        { label: 'Referencie', href: '#references' },
        /* { label: 'Náš tím', href: '#company-life' }, */
        /* { label: 'Kariéra', href: '#career' }, */
        { label: 'Kontakt', href: '#contact' }
      ]
    },
    hero: {
      title: 'Najlepšia lešenárska firma<br class="hidden md:block"> široko ďaleko.',
      subtitle: 'Spoľahlivosť, kvalita a bezpečnosť na každom stavenisku. Váš partner pre profesionálne stavby lešenia.',
      button1: 'Naše referencie',
      button2: 'Kontaktujte nás'
    },
    about: {
      title: 'O nás — spoznajte nás.',
      content: 'Sme mladá firma založená na konci roka 2024. Počas našej existencie sme spolupracovali s firmami z celého Nemecka na väčších aj menších projektoch. Každá zákazka je pre nás zaujímavá, pretože nám prináša nové skúsenosti a posúva nás vpred. Tieto potom môžeme uplatniť v budúcnosti. Je pre nás dôležité podávať dobré výkony, dodržiavať dohody a termíny a zlepšovať naše procesy. Keď sú naši zákazníci a pracovníci spokojní, sme spokojní aj my.'
    },
    services: {
      title: 'Naše Detailné Služby',
      subtitle: 'Ponúkame na mieru šité lešenárske riešenia pre každý projekt, od štandardných aplikácií až po komplexné špeciálne konštrukcie.',
      items: [
        { title: 'Fasádne lešenie', description: 'Ideálne pre rekonštrukcie, zatepľovacie práce a maľovanie fasád. Poskytujeme bezpečný a efektívny prístup k akejkoľvek vonkajšej stene budovy, aby váš projekt prebehol hladko a podľa plánu.' },
        { title: 'Priemyselné lešenie', description: 'Zložité priemyselné prostredia si vyžadujú špecializované riešenia. Navrhujeme a staviame robustné lešenia pre továrne, elektrárne a výrobné haly, ktoré spĺňajú najvyššie štandardy bezpečnosti a prístupnosti.' },
        { title: 'Špeciálne konštrukcie', description: 'Od historických budov až po zložité architektonické návrhy, žiadna výzva nie je príliš veľká. Náš tím navrhuje vlastné lešenárske riešenia pre jedinečné projekty, ktoré si vyžadujú kreatívne myslenie a presnosť.' }
      ]
    },
    safety: {
      title: 'Bezpečnosť na prvom mieste',
      subtitle: 'Náš záväzok k najvyšším bezpečnostným štandardom na každom stavenisku.',
      content: 'Bezpečnosť je základom našej práce. Dôsledne dodržiavame všetky zákonné predpisy a implementujeme aj ďalšie opatrenia na zaistenie bezpečnosti všetkých zúčastnených. Pravidelné školenia, moderné vybavenie a starostlivé plánovanie sú pre nás samozrejmosťou.',
      points: [
        { title: 'Certifikovaní zamestnanci', description: 'Celý náš tím je školený a certifikovaný podľa najnovších štandárdov.' },
        { title: 'Pravidelné inšpekcie', description: 'Všetky lešenia sú pred a počas používania pravidelne kontrolované odborným personálom.' },
        { title: 'Vysokokvalitný materiál', description: 'Používame výhradne testovaný a udržiavaný materiál od renomovaných výrobcov.' },
        { title: 'Osobné ochranné pracovné prostriedky (OOPP)', description: 'Nosenie kompletných OOPP je na našich staveniskách povinné.' }
      ]
    },
    gallery: {
      title: 'Projekty a Referencie',
      subtitle: 'Pozrite si výber našich úspešne dokončených projektov.',
      imageAlt: 'Referencia staveniska'
    },
    companyLife: {
      title: 'Náš Tím, Naša Sila',
      subtitle: 'Základom nášho úspechu sú naši odhodlaní a kvalifikovaní pracovníci.',
      content: 'Každý náš zamestnanec prináša dlhoročné skúsenosti, profesionalitu a vysokú mieru spoľahlivosti. Sme hrdí na tím, ktorý presviedča nielen technickým know-how, ale aj tímovým duchom a odhodlaním pre najvyššie štandardy kvality a bezpečnosti. Práve táto oddanosť nám umožňuje dodávať výnimočné výsledky pri každom projekte.',
      values: ['Tímový duch', 'Skúsenosti', 'Kvalita', 'Energia'],
      quote: '"Každý jednotlivec je dôležitý pre úspech celku."'
    },
    whyUs: {
        points: [
            { title: 'Spoľahlivosť', description: 'Dodržiavame naše termíny a dohody.' },
            { title: 'Kvalita', description: 'Najvyššie štandardy pri materiáloch a realizácii.' },
            { title: 'Bezpečnosť', description: 'Bezpečnosť je u nás na prvom mieste.' }
        ]
    },
    career: {
      title: 'Kariéra v Milok — Prečo my',
      imageAlt: 'Lešenár pri práci',
      benefits: [
        { title: 'Skúsenosti', description: 'Naši lešenári majú dlhoročné skúsenosti v stavbe lešení.' },
        { title: 'Všestrannosť', description: 'Pracujeme s rôznymi systémami lešení ako Layher, Plettac, Peri.' },
        { title: 'Profesionalita', description: 'Spoľahlivosť, kvalita, vysoké pracovné nasadenie a bezpečnosť.' },
        { title: 'Štruktúra tímu', description: '1 vodič nákladného vozidla a 1 nemecky hovoriaci v každej skupine.' }
      ]
    },
    testimonials: {
      title: 'Čo hovoria naši lešenári',
      items: [
        { quote: "S Milokom spolupracujem od marca 2025. Som spokojný s prístupom firmy a peniaze dostávam vždy načas.", author: "Peter" },
        { quote: "Som tu od založenia firmy. Páči sa mi individuálny prístup, peniaze načas a tiež možnosť zlepšovať si nemčinu, ktorú používam každý deň v práci.", author: "František B." },
        { quote: "Vedenie firmy je k dispozícii, keď potrebujem niečo riešiť. Počas turnusu dostávam podporu od vedenia, napr. aj vo forme tlmočenia, keď ma náhle rozbolel zub.", author: "Lukáš B." }
      ]
    },
    stats: {
      title: 'Prečo s nami spolupracovať?',
      items: [
        { title: 'Spokojní partneri', value: '7+', description: 'Silné partnerstvá vybudované v prvom roku.', items: ['Vysoké pracovné nasadenie', 'Flexibilita', '0 nehôd'] },
        { title: 'Naši lešenári', value: '30+', description: 'Nové odborné sily prijaté v prvom roku.', items: ['12 vodičov LKW', '13 nemecky hovoriacich', 'Skúsenosti v priemysle a na fasádach'] },
        { title: 'Projekty', value: '55+', description: 'Úspešne dokončených projektov ročne.', items: ['Školy', 'Nemocnice', 'Obytné budovy a rodinné domy'] }
      ]
    },
    contact: {
      title: 'Tiráž a Kontakt',
      subtitle: 'Máte otázky alebo chcete prediskutovať projekt? Kontaktujte nás!',
      infoTitle: 'Kontaktné informácie',
      presenceTitle: 'Online prítomnosť',
      facebook: 'Naša Facebook stránka',
      whatsapp: 'Stretnutia cez WhatsApp',
      formTitle: 'Napíšte nám správu',
      formThanks: 'Ďakujeme!',
      formSuccess: 'Vaša správa bola úspešne odoslaná. Čoskoro sa vám ozveme.',
      formNewMessage: 'Napísať novú správu',
      formNameLabel: 'Vaše meno',
      formNamePlaceholder: 'Max Novák',
      formEmailLabel: 'Váš e-mail',
      formEmailPlaceholder: 'meno@priklad.com',
      formMessageLabel: 'Vaša správa',
      formMessagePlaceholder: 'Vaša požiadavka...',
      formSendButton: 'Odoslať správu',
      formErrorServer: 'Nepodarilo sa odoslať. Skúste to prosím manuálne:',
      formErrorNetwork: 'Chyba siete. Skúste to prosím manuálne:',
      formSubmitting: 'Odosiela sa...',
      formFallbackButton: 'Otvoriť v e-mailovej aplikácii'
    },
    footer: {
      copyright: 'Copyright &copy; {{year}} by Milok Gerüstbau. Všetky práva vyhradené.'
    }
  },
  en: {
    seo: {
      title: 'Milok Scaffolding - Reliable Scaffolds & Jobs in Germany',
      description: 'Professional scaffolding services across Germany. Looking for a job? Milok offers work for scaffolders, quality equipment, and safety. Contact us!',
      keywords: 'scaffolding, Milok, Germany, scaffolder jobs, construction, scaffolding company'
    },
    header: {
      nav: [
        { label: 'About Us', href: '#aboutus' },
        { label: 'Services', href: '#services' },
        /* { label: 'Safety', href: '#safety' }, */
        { label: 'References', href: '#references' },
        /* { label: 'Our Team', href: '#company-life' }, */
        /* { label: 'Career', href: '#career' }, */
        { label: 'Contact', href: '#contact' }
      ]
    },
    hero: {
      title: 'The best scaffolding company<br class="hidden md:block"> far and wide.',
      subtitle: 'Reliability, quality, and safety on every construction site. Your partner for professional scaffolding.',
      button1: 'Our References',
      button2: 'Contact Us'
    },
    about: {
      title: 'About us — get to know us.',
      content: 'We are a young company founded at the end of 2024. During our existence, we have worked with companies from all over Germany on both large and small projects. Every contract is interesting for us as it brings new experiences and helps us grow. We can then apply these in the future. It is important for us to deliver high-quality services, adhere to agreements and deadlines, and improve our processes. When our customers and workers are satisfied, so are we.'
    },
    services: {
      title: 'Our Detailed Services',
      subtitle: 'We provide tailored scaffolding solutions for any project, from standard applications to complex special constructions.',
      items: [
        { title: 'Facade Scaffolding', description: 'Perfect for renovations, insulation work, and facade painting. We provide safe and efficient access to any building exterior, ensuring your project runs smoothly and on schedule.' },
        { title: 'Industrial Scaffolding', description: 'Complex industrial environments demand specialized solutions. We design and erect robust scaffolding for factories, power plants, and production halls, meeting the highest safety and accessibility standards.' },
        { title: 'Special Constructions', description: 'From historic buildings to complex architectural designs, no challenge is too great. Our team engineers custom scaffolding solutions for unique projects requiring creative thinking and precision.' }
      ]
    },
    safety: {
      title: 'Safety First',
      subtitle: 'Our commitment to the highest safety standards on every construction site.',
      content: 'Safety is the foundation of our work. We strictly adhere to all legal regulations and implement additional measures to ensure the safety of everyone involved. Regular training, modern equipment, and meticulous planning are a matter of course for us.',
      points: [
        { title: 'Certified Employees', description: 'Our entire team is trained and certified according to the latest standards.' },
        { title: 'Regular Inspections', description: 'All scaffolding is regularly inspected by qualified personnel before and during use.' },
        { title: 'High-Quality Material', description: 'We exclusively use tested and maintained material from reputable manufacturers.' },
        { title: 'Personal Protective Equipment (PPE)', description: 'Wearing complete PPE is mandatory on our construction sites.' }
      ]
    },
    gallery: {
      title: 'Projects & References',
      subtitle: 'View a selection of our successfully completed projects.',
      imageAlt: 'Construction site reference'
    },
    companyLife: {
      title: 'Our Team, Our Strength',
      subtitle: 'The foundation of our success is our dedicated and qualified employees.',
      content: 'Each of our employees brings many years of experience, professionalism, and a high degree of reliability. We are proud of a team that excels not only through technical know-how but also through team spirit and commitment to the highest quality and safety standards. It is this dedication that allows us to deliver exceptional results on every project.',
      values: ['Team Spirit', 'Experience', 'Quality', 'Energy'],
      quote: '"Every individual is important to the success of the whole."'
    },
    whyUs: {
        points: [
            { title: 'Reliability', description: 'We keep our deadlines and agreements.' },
            { title: 'Quality', description: 'Highest standards in materials and execution.' },
            { title: 'Safety', description: 'Safety is our top priority.' }
        ]
    },
    career: {
      title: 'Career at Milok — Why Us',
      imageAlt: 'Scaffolder at work',
      benefits: [
        { title: 'Experience', description: 'Our scaffolders have many years of experience in scaffolding.' },
        { title: 'Versatility', description: 'We can work with various scaffolding systems from Layher, Plettac, Peri.' },
        { title: 'Professionalism', description: 'Reliability, quality, high work commitment, and safety.' },
        { title: 'Team Structure', description: '1 truck driver and 1 German speaker in each group.' }
      ]
    },
    testimonials: {
      title: 'What our scaffolders say',
      items: [
        { quote: "I have been working with Milok since March 2025. I am satisfied with the company's approach and I always receive my payment on time.", author: "Peter" },
        { quote: "I've been with the company since its founding. I like the individual approach, timely payments, and the opportunity to improve my German, which I use at work every day.", author: "František B." },
        { quote: "The management is available whenever I need to resolve something. During my shift, I receive support from management, for instance, in the form of interpretation when I had a sudden toothache.", author: "Lukáš B." }
      ]
    },
    stats: {
      title: 'Why cooperate with us?',
      items: [
        { title: 'Satisfied Partners', value: '7+', description: 'Strong partnerships built in the first year.', items: ['High work commitment', 'Flexibility', '0 accidents'] },
        { title: 'Our Scaffolders', value: '30+', description: 'New professionals brought on board in the first year.', items: ['12 truck drivers', '13 German speakers', 'Industry & facade experience'] },
        { title: 'Projects', value: '55+', description: 'Successfully completed projects per year.', items: ['Schools', 'Hospitals', 'Residential & family homes'] }
      ]
    },
    contact: {
      title: 'Imprint & Contact',
      subtitle: 'Do you have questions or want to discuss a project? Contact us!',
      infoTitle: 'Contact Information',
      presenceTitle: 'Online Presence',
      facebook: 'Our Facebook Page',
      whatsapp: 'Meetings via WhatsApp',
      formTitle: 'Send us a message',
      formThanks: 'Thank you!',
      formSuccess: 'Your message has been sent successfully. We will get back to you shortly.',
      formNewMessage: 'Write a new message',
      formNameLabel: 'Your Name',
      formNamePlaceholder: 'John Doe',
      formEmailLabel: 'Your E-Mail',
      formEmailPlaceholder: 'name@example.com',
      formMessageLabel: 'Your Message',
      formMessagePlaceholder: 'Your inquiry...',
      formSendButton: 'Send Message',
      formErrorServer: 'Server error. Please send manually:',
      formErrorNetwork: 'Network error. Please send manually:',
      formSubmitting: 'Sending...',
      formFallbackButton: 'Open in Email App'
    },
    footer: {
      copyright: 'Copyright &copy; {{year}} by Milok Gerüstbau. All rights reserved.'
    }
  }
};